module.exports = __webpack_public_path__ + "img/4_2023-04-20--TERRY-FOX-Duo-dryfit-men.96c6a3ac.jpg";